export const compatibleParams = params => {
  if (params?.lang === 'zht') {
    params.lang = 'zh-Hant';
  }
  if (params?.lang === 'zh-Hans') {
    params.lang = 'zh';
  }
  return params;
};
